import type {
  SupplyAgentLineChange,
  SupplyAgentLogisticsCalculateResponse,
  SupplyAgentSimulateResponse,
} from '@/services/supplyAgentService';

/** Convierte el resultado logístico al shape del overlay de Orden Sugerido (SUP-AGENT-006). */
export function logisticsResultToAgentSimulation(
  data: SupplyAgentLogisticsCalculateResponse,
): SupplyAgentSimulateResponse | null {
  if (data.supplier_id == null || data.warehouse_id == null || data.organization_id == null) {
    return null;
  }
  if (data.status !== 'SUCCESS' && data.status !== 'SUCCESS_WITH_WARNINGS') {
    return null;
  }

  const beforeLines =
    (data.before as { lines_detail?: Record<string, unknown>[] } | undefined)?.lines_detail ?? [];
  const afterLines =
    data.lines_detail ??
    (data.after as { lines_detail?: Record<string, unknown>[] } | undefined)?.lines_detail ??
    [];

  if (afterLines.length === 0) return null;

  const constraintType = String(data.rule?.constraint_type || 'LOGISTICS');
  const changes: SupplyAgentLineChange[] =
    data.changes && data.changes.length > 0
      ? data.changes.map((change) => ({
          product_id: change.product_id,
          sku: change.sku || '',
          old_quantity: change.old_quantity,
          new_quantity: change.new_quantity,
          old_value_euros: change.old_value_euros ?? 0,
          new_value_euros: change.new_value_euros ?? 0,
          reasons: (change.reasons || []).map((reason) => ({
            label: reason.label || 'logistics',
            step: reason.step,
            rule_type: reason.rule_type,
          })),
        }))
      : (data.line_adjustments || []).map((adj) => ({
          product_id: adj.product_id,
          sku: adj.sku || '',
          old_quantity: adj.old_units,
          new_quantity: adj.new_units,
          old_value_euros: 0,
          new_value_euros: 0,
          reasons: [
            {
              label: adj.explanation || adj.reason || 'logistics',
              step: 'logistics',
              rule_type: constraintType,
            },
          ],
        }));

  return {
    status: 'ok',
    supplier_id: data.supplier_id,
    warehouse_id: data.warehouse_id,
    organization_id: data.organization_id,
    before: {
      total_items: beforeLines.length,
      total_lines: beforeLines.length,
      total_amount_euros: 0,
      ...((data.before as object) || {}),
      lines_detail: beforeLines,
    },
    after: {
      total_items: afterLines.length,
      total_lines: afterLines.length,
      total_amount_euros: 0,
      ...((data.after as object) || {}),
      lines_detail: afterLines,
    },
    lines_detail: afterLines,
    changes,
    applied_rules: data.applied_rules?.length
      ? data.applied_rules
      : [
          {
            rule_type: data.rule?.constraint_type || 'LOGISTICS',
            name: data.rule?.external_rule_id || data.rule?.constraint_type || 'logistics',
            id: data.rule?.id,
            engine: 'logistics',
          },
        ],
    policy_notes: data.warnings,
  };
}
